import React, { useState } from "react";
import { AppPage, MimaTable, MimaText } from "../../components";
import styles from "../../assets/styles/News/News.module.scss";
import moment from "moment";

const ViewMoreBroadcast = ({ singleBroadcast }) => {
  const [limit, setLimit] = useState(50);
  const [currentPage, setCurrentPage] = useState(0);

  const onLimitChange = (limit) => {
    setLimit(limit);
    setCurrentPage(0);
  };

  const HtmlContent = ({ content }) => {
    return <div dangerouslySetInnerHTML={{ __html: content }} />;
  };

  const [table, setTable] = useState("BUSINESSTABLE");

  const showProspectsTale = () => {
    setTable("PROSPECTSTABLE");
  };

  const showBusinessesTable = () => {
    setTable("BUSINESSTABLE");
  };
  const showParticipantsTable = () => {
    setTable("PARTICIPANTSTABLE");
  };

  const prospectsTableColumns = [
    {
      Header: "Trading Name",
      accessor: "tradingName",
    },
    {
      Header: "Email",
      accessor: "email",
    },
    {
      Header: "Mobile",
      accessor: "mobile",
    },
  ];
  const businessTableColumns = [
    {
      Header: "Trading Name",
      accessor: "tradingName",
    },
    {
      Header: "Email",
      accessor: "email",
    },
    {
      Header: "Mobile",
      accessor: "mobile",
    },
  ];
  const participantTableColumn = [
    {
      Header: "Email",
      accessor: "email",
    },
    {
      Header: "Mobile",
      accessor: "mobile",
    },
  ];
  return (
    <AppPage pageTitle="More Broadcast Info">
      <div className={styles.container}>
        <div>
          <section className={styles.container_top}>
            <div className={styles.container_top__item}>
              <MimaText variant="body">Broadcast Title:</MimaText>
              <MimaText variant="bodyBold">{singleBroadcast?.title}</MimaText>
            </div>
            <div className={styles.container_top__item}>
              <MimaText variant="body">Broadcast Summary:</MimaText>
              <MimaText variant="bodyBold">{singleBroadcast?.summary}</MimaText>
            </div>
            <div className={styles.container_top__item}>
              <MimaText variant="body">Date Created:</MimaText>
              <MimaText variant="bodyBold">
                {moment(singleBroadcast?.createdAt).format(
                  "DD/MM/YYYY HH:mm a"
                )}
              </MimaText>
            </div>
            <div className={styles.container_top__item}>
              <MimaText variant="body">Action Call:</MimaText>
              <MimaText variant="bodyBold">
                {singleBroadcast?.actionButton?.title}
              </MimaText>
            </div>
            <div className={styles.container_top__item}>
              <MimaText variant="body">Action Url:</MimaText>
              <MimaText variant="bodyBold">
                {singleBroadcast?.actionButton?.url}
              </MimaText>
            </div>
            <div className={styles.container_top__item}>
              <MimaText variant="body">Broadcast For:</MimaText>
              <MimaText variant="bodyBold">{singleBroadcast?.app}</MimaText>
            </div>
            <div className={styles.container_top__item}>
              <MimaText variant="body">Broadcast Channel(s):</MimaText>
              <MimaText variant="bodyBold">
                {singleBroadcast?.channels?.join(", ")}
              </MimaText>
            </div>
            <div className={styles.container_top__item}>
              <MimaText variant="body">Status:</MimaText>
              <MimaText variant="bodyBold">{singleBroadcast?.status}</MimaText>
            </div>
          </section>
          <section className={styles.container_bottom}>
            <MimaText align="center" variant="subtitleBold" mt={2} mb={2}>
              Broadcast Body
            </MimaText>
            <MimaText variant="body">
              <HtmlContent content={singleBroadcast?.content} />
            </MimaText>
          </section>
        </div>
        <div className={styles.imgContainer}>
          <div className={styles.imgContainer_card}>
            <MimaText variant="bodyBold">Broadcast Banner</MimaText>
            {singleBroadcast.bannerUrl ? (
              <img
                src={singleBroadcast?.bannerUrl}
                alt="Banner Url"
                className={styles.imgContainer_img}
              />
            ) : (
              <MimaText variant="subtitleBold" align="center">
                No banner uploaded for this Broadcast
              </MimaText>
            )}
          </div>
        </div>
      </div>

      <div className={styles.switch}>
        <div
          className={`${
            table === "BUSINESSTABLE"
              ? styles.switch__show
              : styles.switch__show_b
          }`}
          onClick={showBusinessesTable}
        >
          Show Recipient Businesses
        </div>
        <div
          className={`${
            table === "PROSPECTSTABLE"
              ? styles.switch__hide
              : styles.switch__hide_b
          }`}
          onClick={showProspectsTale}
        >
          Show Recipient Prospects
        </div>
        <div
          className={`${
            table === "PARTICIPANTSTABLE"
              ? styles.switch__hide
              : styles.switch__hide_b
          }`}
          onClick={showParticipantsTable}
        >
          Show Recipient Participants
        </div>
      </div>

      {table === "BUSINESSTABLE" && (
        <MimaTable
          tableData={singleBroadcast?.businesses}
          tableColumns={businessTableColumns}
          searchPlaceholder="Search Recipient Businesses"
          searchVariant="wide"
          totalItems={singleBroadcast?.businesses.length}
          limit={limit}
          currentPage={currentPage}
          onLimitChange={onLimitChange}
          setCurrentPage={setCurrentPage}
        />
      )}
      {table === "PROSPECTSTABLE" && (
        <MimaTable
          tableData={singleBroadcast?.prospects}
          tableColumns={prospectsTableColumns}
          searchPlaceholder="Search Recipient Prospects"
          searchVariant="wide"
          totalItems={singleBroadcast?.prospects.length}
          limit={limit}
          currentPage={currentPage}
          onLimitChange={onLimitChange}
          setCurrentPage={setCurrentPage}
        />
      )}

      {table === "PARTICIPANTSTABLE" && (
        <MimaTable
          tableData={singleBroadcast?.participants}
          tableColumns={participantTableColumn}
          searchPlaceholder="Search Recipient Participants"
          searchVariant="wide"
          totalItems={singleBroadcast?.participants.length}
          limit={limit}
          currentPage={currentPage}
          onLimitChange={onLimitChange}
          setCurrentPage={setCurrentPage}
        />
      )}
    </AppPage>
  );
};
export default ViewMoreBroadcast;
